export { default as SuccessUpdatePreferences } from './SuccessUpdateConsent';
